export enum ChartTypeEnum {
    Line = 'line',
    Area = 'area',
    Pie = 'pie',
    StackedArea = 'stacked area',
    Funnel3D = 'funnel3d'
}